<template>
  <el-form ref="AccountFrom" :model="account" :rules="rules" label-position="left" label-width="0px"
           class="demo-ruleForm login-container">
    <h3 class="title">登录</h3>
    <el-form-item prop="username">
      <el-input type="text" v-model="account.username" auto-complete="off" placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="pwd">
      <el-input type="password" v-model="account.pwd" auto-complete="off" placeholder="密码"></el-input>
    </el-form-item>
    <el-form-item  prop="type" class="clear-margin-bottom">
      <el-select v-model="account.type" clearable placeholder="机构类型" style="width:100%;">
        <el-option v-for="item in dictOrgType" :key="item.value" :label="item.name" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
    <!--<el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>-->
    <el-form-item style="width:100%;text-align:center;">
      <el-button type="primary" style="width:40%;" @click.native.prevent="handleLogin" :loading="loading">登录</el-button>
      <el-button type="primary" style="width:40%;" @click.native.prevent="handleReg">注册 </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import API from "../api/api_user";
  import LOGIN_API from "../api/api_login";
  import DICT_API from "../api/api_dict";

  export default {
    data() {
      return {
        loading: false,
        dictOrgType: [],
        account: {
          username: "",
          pwd: "",
          type: ""
        },
        rules: {
          username: [
            {required: true, message: "请输入账号", trigger: "blur"}
            //{ validator: validaePass }
          ],
          pwd: [
            {required: true, message: "请输入密码", trigger: "blur"}
            //{ validator: validaePass2 }
          ],
          type: [
            {required: true, message: '请选择机构类型', trigger: 'blur'}
          ]
        },
        checked: true
      };
    },
    mounted: function () {//页面初始化方法
      let  params="";
      let that = this;
      DICT_API.dictOrgType(params)
      .then(
        function (result) {
          if (result && result.code == 200) {
            that.dictOrgType = result.data;
          }
        }
      )
      .catch(function (error) {
        console.log(error);
      });
    },
    methods: {
      handleReg(){
        this.$router.push({path: "/reg"});
      },
      handleLogin() {
        let that = this;
        this.$refs.AccountFrom.validate(valid => {
          if (valid) {
            this.loading = true;
            let loginParams = new FormData();
            //loginParams.append('client_id', 'app');
            //loginParams.append('client_secret', '123456');
            //loginParams.append('grant_type', 'password');
            loginParams.append('type', this.account.type);
            loginParams.append('username', this.account.username);
            loginParams.append('password', this.account.pwd);
            API.login(loginParams)
              .then(
                function (result) {
                  // console.log(result)
                  that.loading = false;
                  if (result && result.code == 200) {
                    var data=JSON.stringify(result.data);
                     //console.log(result.data.organization.id);
                    window.localStorage.setItem("access-user",data);
                    if(result.data.organization == undefined){
                      that.$router.push({path: "/"});
                     
                    }else{
                       if(result.data.adminAccount || result.data.organization.agree){
                          that.$router.push({path: "/"});
                      } else {
                          that.$router.push({path: "/agree"});
                      }
                    }
                  } else {
                    that.$message.error({
                      showClose: true,
                      message: result.msg || "登录失败",
                      duration: 2000
                    });
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function (error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          }
        });
      }
    }
  };
</script>
<style>
  body {
    margin:0;
    padding:0;
    width:100%;
    height:100%;
    /* background:url("../assets/images/loginbg.png"); */
     background-size: cover;
    background-position:top;
    font: 14px/1.5 tahoma,arial,'Hiragino Sans GB','\5b8b\4f53',sans-serif;
    -webkit-font-smoothing: antialiased;
    font-weight: 300;
  }
</style>
<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 160px auto;
    width: 450px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;

    background: -ms-linear-gradient(top, #ace, #00c1de); /* IE 10 */
    background: -moz-linear-gradient(top, #ace, #00c1de); /*火狐*/
    background: -webkit-gradient(
        linear,
        0% 0%,
        0% 100%,
        from(#ace),
        to(#00c1de)
    ); /*谷歌*/
    background: -webkit-linear-gradient(
        top,
        #ace,
        #00c1de
    ); /*Safari5.1 Chrome 10+*/
    background: -o-linear-gradient(top, #ace, #00c1de); /*Opera 11.10+*/

    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }

    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// Login.vue?b13034e8